
import { defineComponent } from "vue";
import ResidentsIcon from "@/components/icons/Residents.vue";
import SettingsIcon from "@/components/icons/Settings.vue";
import DocumentsIcon from "@/components/icons/Documents.vue";
import PropertyOption from "@/components/property/PropertyOption.vue";
import LotIcon from "@/components/icons/Lot.vue";
import { useRouter } from "vue-router";
import { useActiveProperty } from "@/util/properties";

export default defineComponent({
  components: {
    ResidentsIcon,
    PropertyOption,
    SettingsIcon,
    DocumentsIcon,
    LotIcon,
  },
  props: {
    noMarginX: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const router = useRouter();
    const property = useActiveProperty();

    return {
      toResidents() {
        if (property.value == null) return;
        router.push({
          name: "properties.residents.list",
          params: { id: property.value.id },
        });
      },
      toLots() {
        if (property.value == null) return;
        router.push({
          name: "lots.list",
        });
      },
      toFinances() {
        if (property.value == null) return;
        router.push({
          name: "accounting.overview.transactions",
        });
      },
      toSettings() {
        if (property.value == null) return;
        router.push({
          name: "properties.edit",
          params: { id: property.value.id },
        });
      },
    };
  },
});
